import { EditorState, ContentState } from 'draft-js';
import { stateFromHTML } from 'draft-js-import-html';
import { isHTMLString } from '../../utils/string';

export const getEditableDraftContent = (
  content: string | EditorState | null | undefined,
): EditorState => {
  if (!content) {
    return EditorState.createWithContent(stateFromHTML(''));
  } else if (typeof content === 'string') {
    if (isHTMLString(content)) {
      return EditorState.createWithContent(stateFromHTML(content));
    }

    return EditorState.createWithContent(ContentState.createFromText(content));
  }

  return content;
};
